import { type FC } from "react";

export const DoneRound: FC = () => (
  <svg
    width="113"
    height="113"
    viewBox="0 0 113 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="56.5" cy="56.5002" r="37.6667" fill="#BCFFC7" />
    <path
      d="M40.0208 51.7917L50.8165 62.5874C52.6553 64.4261 55.6364 64.4261 57.4751 62.5874L91.8125 28.25"
      stroke="#35424A"
      strokeWidth="5.65"
      strokeLinecap="round"
    />
  </svg>
);
